import React from 'react'
import icons from '../../common/IconReference.json'
import constants from '../../common/constants'
import texts from '../../common/texts.json'
import { Truck as TruckIcon } from '@walmart-web/livingdesign-icons'

export const getDeliveryIcon = (hasFreeShipping) =>
  hasFreeShipping ? icons.DELIVERY_TRUCK_NO_PRICE_ICON : <TruckIcon size="small" />

export const getDeliveryText = (hasFreeShipping) =>
  hasFreeShipping ? texts.PRODUCT_DETAIL.FREE_SHIPPING : texts.PRODUCT_DETAIL.DELIVERY_AVAILABLE

export const getDiscountBase = ({ price }) => {
  const normalPrice = parseInt(price.BasePriceReference, 0)
  const actualPrice = parseInt(price.BasePriceSales, 0)
  if (actualPrice > 0 && normalPrice > actualPrice) {
    return 100 - Math.round((actualPrice * 100) / normalPrice)
  }
  return 0
}

export const getColorForUnits = (maxUnits) => (maxUnits === constants.maxQuantity.UNLIMITED ? '#000' : 'red')

export const isProductAvailableToSell = (product, blackListProductToSell = []) =>
  product.available && !blackListProductToSell.some((value) => value === product.sku)
